// src/components/dataone/WarrantiesTable.tsx
import React from 'react';

interface Warranty {
  name: string;
  type: string;
  months: string;
  miles: string;
}

export default function WarrantiesTable({ warranties }: { warranties: Warranty[] }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">Warranties</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border border-gray-300 rounded">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Type</th>
              <th className="px-3 py-2">Duration (Months)</th>
              <th className="px-3 py-2">Coverage (Miles)</th>
            </tr>
          </thead>
          <tbody>
            {warranties.map((w, i) => (
              <tr key={i} className="border-t">
                <td className="px-3 py-1">{w.name}</td>
                <td className="px-3 py-1">{w.type}</td>
                <td className="px-3 py-1">{w.months}</td>
                <td className="px-3 py-1">{w.miles}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
